module.exports = __webpack_public_path__ + "img/qingxuguanli.bcdb8f87.png";